var React = require('react');

function IconSDownSolid (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M234.2 339.8l267.7 339.8c4.8 6.1 12.7 6.1 17.5 0L787 339.8"}));
}

IconSDownSolid.displayName = "IconSDownSolid";

IconSDownSolid.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconSDownSolid;

IconSDownSolid.default = IconSDownSolid;
